module.exports = __webpack_public_path__ + "static/media/arrow-hand-drawn.398004e0.svg";